import { ArrowUpRight, Mail, Phone, Rocket } from "lucide-react";

const quickLinks = [
    { label: "About the studio", href: "/#about" },
    { label: "Services", href: "/#services" },
    { label: "Case studies", href: "/#work" },
    { label: "Blog", href: "/#insights" },
    { label: "Contact", href: "/#contact" },
];

const recentPosts = [
    { date: "20 Feb, 2026", title: "The end of the brand book" },
    { date: "12 Feb, 2026", title: "Your homepage hero isn't a hero" },
];

export default function DigtekFooter() {
    return (
        <footer
            data-testid="digtek-footer"
            className="relative bg-digtek-header text-white pt-20 pb-8 overflow-hidden"
        >
            <div className="digtek-blob purple w-[520px] h-[520px] -left-40 top-20 opacity-40" />

            <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 mb-14">
                    {/* Brand */}
                    <div className="lg:col-span-4">
                        <a
                            href="/"
                            className="inline-flex items-center gap-3 mb-6"
                        >
                            <span className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-digtek-lime text-digtek-header">
                                <Rocket className="w-5 h-5 rotate-45" />
                            </span>
                            <span className="font-display font-bold text-2xl text-white">
                                Aximo<span className="text-digtek-lime">.</span>
                            </span>
                        </a>
                        <p className="text-white/70 leading-relaxed max-w-[340px] mb-6">
                            The growth studio behind the brands you'll be
                            Googling next year. Strategy, content, paid,
                            engineered digital — one operating rhythm.
                        </p>
                        <div className="flex items-center gap-3">
                            {["𝕏", "in", "IG", "YT"].map((s) => (
                                <a
                                    key={s}
                                    href="#"
                                    className="w-11 h-11 rounded-full bg-white/10 hover:bg-digtek-lime hover:text-digtek-header flex items-center justify-center text-sm font-bold transition-colors"
                                >
                                    {s}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick links */}
                    <div className="lg:col-span-2">
                        <h4 className="text-digtek-lime font-display font-bold text-lg mb-5">
                            Quick links
                        </h4>
                        <ul className="space-y-3">
                            {quickLinks.map((l) => (
                                <li key={l.href}>
                                    <a
                                        href={l.href}
                                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                                        className="text-white/80 hover:text-digtek-lime transition-colors text-sm inline-flex items-center gap-2 group"
                                    >
                                        <ArrowUpRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                                        {l.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Recent posts */}
                    <div className="lg:col-span-3">
                        <h4 className="text-digtek-lime font-display font-bold text-lg mb-5">
                            Recent posts
                        </h4>
                        <ul className="space-y-5">
                            {recentPosts.map((p) => (
                                <li key={p.title} className="flex gap-3">
                                    <div className="w-14 h-14 rounded-xl bg-digtek-purple flex items-center justify-center shrink-0">
                                        <span className="text-digtek-lime font-display font-bold text-xl">
                                            A.
                                        </span>
                                    </div>
                                    <div>
                                        <p className="text-white/50 text-xs mb-1">
                                            {p.date}
                                        </p>
                                        <p className="text-white text-sm font-semibold hover:text-digtek-lime transition-colors cursor-pointer">
                                            {p.title}
                                        </p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="lg:col-span-3">
                        <h4 className="text-digtek-lime font-display font-bold text-lg mb-5">
                            Get in touch
                        </h4>
                        <ul className="space-y-3">
                            <li>
                                <a
                                    href="mailto:info@aximo.studio"
                                    className="text-white/80 hover:text-digtek-lime transition-colors inline-flex items-center gap-2"
                                >
                                    <Mail className="w-4 h-4" />
                                    info@aximo.studio
                                </a>
                            </li>
                            <li>
                                <a
                                    href="tel:+16464447966"
                                    className="text-white/80 hover:text-digtek-lime transition-colors inline-flex items-center gap-2"
                                >
                                    <Phone className="w-4 h-4" />
                                    +1 (646) 444-7966
                                </a>
                            </li>
                        </ul>
                        <div className="mt-6 flex items-center gap-2 text-xs text-white/50">
                            <input
                                type="checkbox"
                                defaultChecked
                                className="accent-digtek-lime"
                            />
                            <span>
                                I agree to the{" "}
                                <a href="#" className="text-digtek-lime">
                                    Privacy Policy
                                </a>
                                .
                            </span>
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-white/50">
                    <p>© All Copyright 2026 by Aximo Studios</p>
                    <div className="flex items-center gap-6">
                        <a href="#" className="hover:text-digtek-lime">
                            Terms & Conditions
                        </a>
                        <a href="#" className="hover:text-digtek-lime">
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
